<lum-order-transfer-form
  (bulkReceiveEvent)="bulkReceiveUpdatedItems($event)"
></lum-order-transfer-form>
